import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { IconArrowLeft } from '@xing-com/icons';
import { Section } from '@xing-com/layout-primitives';
import {
  mediaTopBarHidden,
  zIndexElevatedLayer5,
} from '@xing-com/layout-tokens';
import {
  spaceS,
  spaceL,
  spaceXXL,
  scale010,
  scale170,
  xdlColorBackground,
  xdlColorBorderSoft,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

import { ActivityCenterButton } from './activity-center-button';
import { LoginButton } from './login-button';

// Important note:
// Temporary small screen header for logged out users, to act as a subheader for an experiment
// It includes a back button and a title
// Copied from `packages/layout/header/src/header.tsx` and simplified
// TODO: Clean after the experiment is done or logic has been integrated into the platform layout
export const SmallScreenHeaderLoggedOut: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <StyledHeaderWrapper>
      <Section noBlockPadding>
        <StyledHeader>
          <Button
            icon={IconArrowLeft}
            to="/"
            aria-label={formatMessage({
              id: 'TOP_BAR_BACK_BUTTON_ARIA_LABEL',
            })}
          />
          <Headline size="large" noMargin>
            <FormattedMessage id="FRAME_HEADER_SEARCH" />
          </Headline>
          <StyledOuterActionsContainer aria-label="header-navigation" as="nav">
            <ActivityCenterButton
              title={formatMessage({ id: 'MAINNAV_ACTIVITY_CENTER' })}
              href="https://www.xing.com/activity?sc_o=navigation_activity"
            />
            <ActionButtonSpace>
              <LoginButton />
            </ActionButtonSpace>
          </StyledOuterActionsContainer>
        </StyledHeader>
      </Section>
    </StyledHeaderWrapper>
  );
};

const StyledHeaderWrapper = styled.header`
  background-color: ${xdlColorBackground};
  border-bottom: ${scale010} solid ${xdlColorBorderSoft};
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: calc(${zIndexElevatedLayer5} - 50);
  height: ${scale170};

  @media ${mediaTopBarHidden} {
    display: none;
  }
`;

const StyledHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 auto;
  flex-wrap: nowrap;
  height: ${scale170};
`;

const StyledOuterActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: calc(-1 * ${spaceS});

  @media ${mediaTopBarHidden} {
    gap: ${spaceS};
  }

  @media (min-width: 1428px) {
    gap: ${spaceL};
  }

  @media (min-width: 1572px) {
    gap: ${spaceXXL};
  }
`;

const ActionButtonSpace = styled.div`
  padding: ${spaceS};
`;
